import facepaint from 'facepaint';
export const breakpoints = {
    mobile: 420,
    tablet: 920,
    desktop: 1120,
};
export const mq = facepaint([
    `@media(min-width: ${breakpoints.mobile}px)`,
    `@media(min-width: ${breakpoints.tablet}px)`,
    `@media(min-width: ${breakpoints.desktop}px)`,
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2l2ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdHlsZXMvcmVzcG9uc2l2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFNBQVMsTUFBTSxXQUFXLENBQUE7QUFFakMsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHO0lBQ3pCLE1BQU0sRUFBRSxHQUFHO0lBQ1gsTUFBTSxFQUFFLEdBQUc7SUFDWCxPQUFPLEVBQUUsSUFBSTtDQUNkLENBQUE7QUFFRCxNQUFNLENBQUMsTUFBTSxFQUFFLEdBQUcsU0FBUyxDQUFDO0lBQzFCLHFCQUFxQixXQUFXLENBQUMsTUFBTSxLQUFLO0lBQzVDLHFCQUFxQixXQUFXLENBQUMsTUFBTSxLQUFLO0lBQzVDLHFCQUFxQixXQUFXLENBQUMsT0FBTyxLQUFLO0NBQzlDLENBQUMsQ0FBQSJ9